import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
	mode: 'history',
	history: createWebHistory(),
	routes: [
		{
			path: '/jobs/list',
			component: () => import('./redesign/Jobs/ListOfJobs.vue'
			),
			children: [
				{
					path: '',
					component: () => import( './redesign/Jobs/JobsDefault.vue'
					),
				},
				{
					path: 'job-rates',
					component: () => import( './redesign/Jobs/JobRates.vue'
					),
				},
			],
		},
		{
			path: '/resetPassword/:token',
			name: 'reset-password',
			component: () => import('./redesign/Authorization/ResetPassword.vue'
			),
		},
		{
			path: '/verifyEmail/:token',
			name: 'verify-email',
			component: () => import( './redesign/Authorization/VerifyEmail.vue'
			),
		},
		{
			path: '/skills',
			name: 'skills',
			component: () => import('./redesign/Skills/Skills.vue'),
		},
		{
			path: '/shiftPlan/menu',
			name: 'shift-Plan-Menu',
			component: () => import( './redesign/ShiftPlans/Main.vue'
			),
		},
		{
			path: '/shiftPlan/createNewPlan',
			name: 'create-shift-Plan-Menu',
			component: () => import( './redesign/ShiftPlans/StepOne.vue'
			),
		},
		{
			path: '/shiftPlan/savedTemplate/summary/:id',
			name: 'saved-shift-Planner-Summary',
			component: () => import( './redesign/ShiftPlans/ShowSelectedPlannerTemplates.vue'
			),
		},
		{
			path: '/shiftPlan/addPerson',
			name: 'create-shift-Plan-wizard',
			component: () => import( './redesign/ShiftPlans/CreateShiftPlanWizard.vue'
			),
		},
		{
			path: '/shiftPlan/addPerson/:id',
			name: 'add-person-shift-Plan-wizard',
			component: () => import( './redesign/ShiftPlans/CreateShiftPlanWizard.vue'
			),
		},
		{
			path: '/learning/journey/report',
			name: 'learning-journey-report',
			component: () => import( './redesign/LearningJourneyReport/MainReportView.vue'
			),
		},
		{
			path: '/roster-setup-list',
			name: 'roster-setup-list',
			component: () => import( './redesign/Roster/RosterSetupList.vue'
			),
		},
		{
			path: '/new-roster-setup',
			name: 'new-roster-setup',
			component: () => import( './redesign/Roster/CreateRosterSetup.vue'
			),
		},
		{
			path: '/edit-roster-setup/:id',
			name: 'edit-roster-setup',
			component: () => import( './redesign/Roster/CreateRosterSetup.vue'
			),
		},
		{
			path: '/staff-roster-availability-actions',
			name: 'staff-roster-availability-actions',
			component: () => import( './redesign/Roster/StaffRosterAvailability.vue'
			),
		},
		{
			path: '/feedbacks/list',
			name: 'feedbacks',
			component: () => import('./redesign/Feedbacks/ListOfFeedbacks.vue'
			),
		},
		{
			path: '/managers/list',
			name: 'managers',
			component: () => import( './redesign/ManagerList/ManagersList.vue'
			),
		},
		{
			path: '/tags/list',
			name: 'tags',
			component: () => import( './redesign/Tags/Tags.vue'
			),
		},
		{
			path: '/persona-create-configuration',
			name: 'persona-create-configuration',
			component: () => import( './redesign/Persona/CreatePersona.vue'
			),
		},
		{
			path: '/persona-edit-configuration/:id',
			name: 'persona-edit-configuration',
			component: () => import( './redesign/Persona/CreatePersona.vue'
			),
		},
		{
			path: '/persona-clone-configuration/:id',
			name: 'persona-clone-configuration',
			component: () => import( './redesign/Persona/ClonePersona.vue'
			),
		},
		{
			path: '/persona-list-configuration',
			name: 'persona-list-configuration',
			component: () => import( './redesign/Persona/PersonaList.vue'
			),
		},
		{
			path: '/staffPersonaMappings/list',
			name: 'staffPersonaMappings',
			component: () => import( './redesign/StaffPersonaMappings/Main.vue'
			),
		},
		{
			path: '/care/speciality/configuration',
			name: 'careSpecialityConfig',
			component: () => import('./redesign/Configuration/CareSpeciailityConfig.vue'
			),
		},
		{
			path: '/trust-care-specialities',
			name: 'trustCareSpecialityList',
			component: () => import( './redesign/Trust/CareSpecialitiesList.vue'
			),
		},
		{
			path: '/jobTemplateMappings/list',
			name: 'jobTemplateMappings',
			component: () => import( './redesign/JobTemplateMappings/Main.vue'
			),
		},
		{
			path: '/managers/add',
			name: 'add-manager',
			component: () => import( './redesign/ManagerList/AddManager.vue'
			),
		},
		{
			path: '/job-templates',
			name: 'job-templates',
			component: () => import('./redesign/JobTemplate/JobTemplate.vue'),
		},
		{
			path: '/delete/user/acouunt/instruction',
			name: 'delete-user-account-instruction',
			component: () => import( './redesign/Authorization/DeleteAccountInstruction.vue'
			),
		},
		{
			path: '/job-matching-predictions',
			name: 'job-matching-predictions',
			component: () => import( './redesign/Jobs/JobMatchingPredictions.vue'
			),
		},
		{
			path: '/feedback-settings',
			name: 'feedback-settings',
			component: () => import( './redesign/FeedbackSettings/Settings.vue'
			),
		},
		{
			path: '/system-settings',
			name: 'system-settings',
			component: () => import('./redesign/SystemSettings/Main.vue'
			),
			children: [
				{
					path: 'bank-rates',
					name: 'bank-rates',
				},
				{
					path: 'shift-length',
					name: 'shift-length',
				},
			],
		},
		{
			path: '/users/settings',
			name: 'users-settings',
			component: () => import('./redesign/Users/UserDetails.vue'
			),
		},
		{
			path: '/jobs/new',
			name: 'create-new-job',
			component: () => import('./redesign/Jobs/CreateJobWizard.vue'
			),
		},
		{
			path: '/motivation-questionarrie/new',
			name: 'create-motivation-questionarrie',
			component: () => import( './redesign/UserPreferences/CreateMotivationQuestionarrie.vue'
			),
		},
		{
			path: '/product-configuration/new',
			name: 'create-product-configuration',
			component: () => import( './redesign/Admin/CreateProductConfiguration.vue'
			),
		},
		{
			path: '/rank-motivator/new',
			name: 'create-rank-motivator',
			component: () => import('./redesign/UserPreferences/CreateRankMotivator.vue'
			),
		},
		{
			path: '/checklist-item/new',
			name: 'create-checklist-item',
			component: () => import( './redesign/RateEsclationConfiguration/CreateChecklistItem.vue'
			),
		},
		{
			path: '/checklist-item/edit/:id',
			name: 'edit-checklist-item',
			component: () => import( './redesign/RateEsclationConfiguration/CreateChecklistItem.vue'
			),
		},
		{
			path: '/approve-reason/new',
			name: 'create-approve-reason',
			component: () => import( './redesign/RateEsclationConfiguration/CreateApproveReason.vue'
			),
		},
		{
			path: '/approve-reason/edit/:id',
			name: 'edit-approve-reason',
			component: () => import( './redesign/RateEsclationConfiguration/CreateApproveReason.vue'
			),
		},
		{
			path: '/reject-reason/new',
			name: 'create-reject-reason',
			component: () => import( './redesign/RateEsclationConfiguration/CreateRejectReason.vue'
			),
		},
		{
			path: '/reject-reason/edit/:id',
			name: 'edit-reject-reason',
			component: () => import( './redesign/RateEsclationConfiguration/CreateRejectReason.vue'
			),
		},
		{
			path: '/motivation-questionarrie/edit/:theme',
			name: 'create-motivation-questionarrie-theme',
			component: () => import( './redesign/UserPreferences/CreateMotivationQuestionarrie.vue'
			),
		},
		{
			path: '/product-configuration/edit/:id',
			name: 'edit-product-configuration',
			component: () => import('./redesign/Admin/CreateProductConfiguration.vue'
			),
		},
		{
			path: '/jobs/:id/details',
			name: 'job-details',
			component: () => import('./redesign/Jobs/ViewJob.vue'
			),
		},
		{
			path: '/jobs/:id/editSkills',
			name: 'job-editSkills',
			component: () => import('./redesign/Jobs/EditJobWizard.vue'
			),
		},
		{
			path: '/jobs/:id/addProvisions',
			name: 'job-addProvisions',
			component: () => import('./redesign/Jobs/AddProvisions.vue'
			),
		},
		{
			path: '/trust/bands',
			name: 'trust-bands',
			component: () => import( './redesign/BandMapping/TrustBandList.vue'
			),
		},
		{
			path: '/trust/bands/mapping/:id',
			name: 'trust-bands-mapping',
			component: () => import('./redesign/BandMapping/OptimaBandMapping.vue'
			),
		},
		{
			path: '/trust/job/titles/type',
			name: 'trust-job-titles-type',
			component: () => import('./redesign/JobTitleType/TrustJobTitleType.vue'
			),
		},
		{
			path: '/optima/mapping/configuration',
			name: 'optima-mapping-configuration',
			component: () => import( './redesign/Optima/OptimaMappingPage.vue'
			),
		},
		{
			path: '/drafted/shift/configuration',
			name: 'drafted-shift-configuration',
			component: () => import( './redesign/Configuration/DraftedShiftChecklistConfiguration.vue'
			),
		},
		{
			path: '/optima/shift/configuration',
			name: 'optima-shift-configuration',
			component: () => import( './redesign/Optima/OptimaShiftConfiguration.vue'
			),
		},
		{
			path: '/trust/job/titles/type/mapping/:id',
			name: 'trust-job-titles-type-mapping',
			component: () => import( './redesign/JobTitleType/OptimaJobTitleMapping.vue'
			),
		},
		{
			path: '/jobs/:id/applicants',
			name: 'job-applicants',
			component: () => import( './redesign/Jobs/ViewJob.vue'
			),
		},
		{
			path: '/jobs/:id/rates',
			name: 'job-rates',
			component: () => import( './redesign/Jobs/ViewJob.vue'
			),
		},
		{
			path: '/jobs/:id/eligible-candidates',
			name: 'eligible-candidates',
			component: () => import( './redesign/Jobs/ViewJob.vue'
			),
		},
		{
			path: '/jobs/:id/rates/:rateId',
			name: 'edit-job-rates',
			component: () => import( './redesign/Jobs/ViewJob.vue'
			),
		},
		{
			path: '/sign-in',
			name: 'sign-in',
			component: () => import(
				/* webpackChunkName: "authorization" */ './redesign/Authorization/Authorization.vue'
			),
		},
		{
			path: '/sign-up',
			name: 'sign-up',
			component: () => import(
				/* webpackChunkName: "authorization" */ './redesign/Authorization/Authorization.vue'
			),
		},
		{
			path: '/ManagerVerifyEmail/:token/:firstname/:lastname/:email',
			name: 'manager-verify-email',
			component: () => import(
				/* webpackChunkName: "authorization" */ './redesign/Authorization/ManagerInvitePage.vue'
			),
		},
		{
			path: '/forgot-password',
			name: 'forgot-password',
			component: () => import(
				/* webpackChunkName: "authorization" */ './redesign/Authorization/ForgotPassword.vue'
			),
		},
		{
			path: '/users/:id',
			name: 'userDetails',
			// route level code-splitting
			// this generates a separate chunk (user-details.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import( './redesign/UserList/userDetailsPage.vue'
			),
		},
		{
			path: '/users/:id/:requestId',
			name: 'user',
			component: () => import( './redesign/Users/UserDetails.vue'
			),
		},
		{
			path: '/messages',
			name: 'messageslist',
			component: () => import( './redesign/Messenger/Main.vue'
			),
		},
		{
			path: '/messages/:chatRoomId',
			name: 'messages',
			component: () => import('./redesign/Messenger/Main.vue'
			),
		},
		{
			path: '/old/table',
			name: 'predictions',
			component: () => import('./containers/Table/Table.vue'),
		},
		// {
		// 	path: '/institution',
		// 	name: 'institution',
		// 	component: () => import( './containers/Institution/InstitutionDetails.vue'
		// 	),
		// },
		{
			path: '/new-trust',
			name: 'trust',
			component: () => import( './redesign/Trust/CreateTrustSetupWizard.vue'
			),
		},
		{
			path: '/trust/:id/statistics-details',
			name: 'statisticsDetails',
			component: () => import( './redesign/Trust/TrustStatisctics.vue'
			),
		},
		{
			path: '/trust/:id/admin-invite',
			name: 'trustAdminInvite',
			component: () => import( './redesign/Trust/AssignTrustAdmin.vue'
			),
		},
		{
			path: '/trustDetails',
			name: 'trustDetails',
			component: () => import( './redesign/AdministrativeGroups/TrustDetails.vue'
			),
		},
		{
			path: '/trust-lists',
			name: 'trustList',
			component: () => import( './redesign/Trust/TrustList.vue'
			),
		},
		{
			path: '/weight-adjuster',
			name: 'weightAdjuster',
			component: () => import( './redesign/Trust/WeightAdjuster.vue'
			),
		},
		{
			path: '/campaign/list',
			name: 'interventionList',
			component: () => import( './redesign/Intervention/Dashboard.vue'
			),
		},
		{
			path: '/campaign/new',
			name: 'createIntervention',
			component: () => import( './redesign/Intervention/CreateIntervention.vue'
			),
		},
		{
			path: '/campaign/:id/edit',
			name: 'updateIntervention',
			component: () => import('./redesign/Intervention/CreateIntervention.vue'
			),
		},
		{
			path: '/campaign/:id/details',
			name: 'campaignDetails',
			component: () => import( './redesign/Intervention/CampaignDetails.vue'
			),
		},
		{
			path: '/incentive/list',
			name: 'incentiveList',
			component: () => import( './redesign/ShiftIntervention/IncentiveList.vue'
			),
		},
		{
			path: '/notification-settings',
			name: 'notificationSettings',
			component: () => import( './redesign/Notifications/NotificationSettings.vue'
			),
		},
		{
			path: '/login-default',
			name: 'loginDefault',
			component: () => import( './redesign/components/DefaultPage.vue'
			),
		},
		{
			path: '/staff-profile-configuration',
			name: 'staffProfileConfiguration',
			component: () => import( './redesign/Configuration/StaffProfileConfiguration.vue'
			),
		},
		{
			path: '/new-feature-introduction',
			name: 'newFeatureIntroduction',
			component: () => import( './redesign/Configuration/NewFeatureIntroduction.vue'
			),
		},
		{
			path: '/create-new-feature-introduction',
			name: 'CreateNewFeatureIntroduction',
			component: () => import( './redesign/Configuration/CreateNewFeature.vue'
			),
		},
		{
			path: '/edit/:id/feature/introduction',
			name: 'EditNewFeatureIntroduction',
			component: () => import( './redesign/Configuration/CreateNewFeature.vue'
			),
		},
		{
			path: '/incentive/new',
			name: 'createIncentive',
			component: () => import( './redesign/ShiftIntervention/CreateShiftIncentive.vue'
			),
		},
		{
			path: '/incentive/provisonList',
			name: 'provisionList',
			component: () => import( './redesign/ShiftIntervention/ManagersProvisionList.vue'
			),
		},
		{
			path: '/incentive/:id/edit',
			name: 'editIncentive',
			component: () => import( './redesign/ShiftIntervention/CreateShiftIncentive.vue'
			),
		},
		{
			path: '/incentiveReason/new',
			name: 'createIncentiveReasons',
			component: () => import( './redesign/ShiftIntervention/CreateIncentiveReason.vue'
			),
		},
		{
			path: '/blockedReason/new',
			name: 'blockedReason',
			component: () => import( './redesign/UserList/blockedReason.vue'
			),
		},

		{
			path: '/autoOfferConfiguration',
			name: 'autoOfferConfiguration',
			component: () => import( './redesign/AutoOfferConfiguration/AutoOffer.vue'
			),
		},

		{
			path: '/masterShiftTimeConfiguration',
			name: 'masterShiftTime',
			component: () => import( './redesign/AdministrativeGroups/MasterShift.vue'
			),
		},
		{
			path: '/customiseTemplateConfiguration',
			name: 'customiseTemplate',
			component: () => import( './redesign/AdministrativeGroups/CustomiseTemplate.vue'
			),
		},
		{
			path: '/customiseTemplateList',
			name: 'customiseTemplateList',
			component: () => import( './redesign/AdministrativeGroups/CustomiseTemplateList.vue'
			),
		},
		{
			path: '/pendingEndorsementRequestList',
			name: 'pendingEndorsementRequestList',
			component: () => import( './redesign/EndorsementRequests/PendingEndorsementRequestList.vue'
			),
		},
		{
			path: '/completedEndorsementRequestList',
			name: 'completedEndorsementRequestList',
			component: () => import( './redesign/EndorsementRequests/CompletedEndorsementRequestList.vue'
			),
		},
		{
			path: '/userList',
			name: 'userList',
			component: () => import( './redesign/UserList/User.vue'
			),
			children: [
				{
					path: 'pendingStaff', 
					name: 'pendingStaff',
				},
				{
					path: 'approvedStaff',
					name: 'approvedStaff',
				},
				{
					path: 'rejectedStaff',
					name: 'rejectedStaff',
				},
				{
					path: 'deletedStaff',
					name: 'deletedStaff',
				},
			],
		},
		{
			path: '/userPermissions/:userId',
			name: 'userPermissions',
			component: () => import( './redesign/UserList/UserPermissions.vue'
			),
		},
		{
			path: '/newSimilarJob/:id',
			name: 'similarjob',
			component: () => import( './redesign/Jobs/PostSimilarJob.vue'
			),
		},
		{
			path: '/pay-rate-configuration',
			name: 'payRateConfig',
			component: () => import( './redesign/PayRateConfiguration/MainList.vue'
			),
		},
		{
			path: '/add-new-rate-configuration',
			name: 'addNewRate',
			component: () => import( './redesign/PayRateConfiguration/AddPayRate.vue'
			),
		},
		{
			path: '/:id/rate-configuration',
			name: 'addNewRate',
			component: () => import( './redesign/PayRateConfiguration/AddPayRate.vue'
			),
		},
		{
			path: '/rightToWorkRequests',
			name: 'rightToWorkRequests',
			component: () => import( './redesign/RightToWorkRequests/Main.vue'
			),
			children: [
				{
					path: 'pending',
					name: 'pending',
				},
				{
					path: 'approved',
					name: 'approved',
				},
				{
					path: 'rejected',
					name: 'rejected',
				},
			],
		},
		{
			path: '/nurseUsers',
			name: 'nurseUsers',
			component: () => import( './redesign/Manager/nurseUsers.vue'
			),
			children: [
				{
					path: 'pendingUser',
					name: 'pendingUser',
				},
				{
					path: 'approvedUser',
					name: 'approvedUser',
				},
				{
					path: 'rejectedUser',
					name: 'rejectedUser',
				},
				{
					path: 'deletedUser',
					name: 'deletedUser',
				},
			],
		},
		{
			path: '/modelJobList',
			name: 'modelJobList',
			component: () => import( './redesign/ModelJobs/ModelJobList.vue'
			),
		},
		{
			path: '/modelJobs/new',
			name: 'create-new-model-job',
			component: () => import( './redesign/ModelJobs/CreateModelJobWizard.vue'
			),
		},
		{
			path: '/modelJobs/edit/:id',
			name: 'edit-model-job',
			component: () => import( './redesign/ModelJobs/CreateModelJobWizard.vue'
			),
		},
		{
			path: '/modelJobs/:id/eligibleCandidateList',
			name: 'EligibleCandidateList',
			component: () => import('./redesign/ModelJobs/EligibleCandidates.vue'
			),
		},
		// {
		// 	path: '/old/institution/:id',
		// 	name: 'institutionDetails',
		// 	component: () => import( './containers/Institution/InstitutionDetails.vue'
		// 	),
		// },
		// {
		// 	path: '/old/institution/budgets/:id',
		// 	name: 'budget',
		// 	component: () => import( './containers/Institution/BudgetDetails.vue'
		// 	),
		// },
		{
			path: '/options',
			name: 'options',
			component: () => import( './containers/Options/Options.vue'
			),
		},
		{
			path: '/export-preferences',
			name: 'export-preferences',
			component: () => import( './redesign/UserPreferences/ExportPreferences.vue'
			),
		},
		{
			path: '/preferences-configuration',
			name: 'preferences-configuration',
			component: () => import( './redesign/UserPreferences/Configuration.vue'
			),
		},
		{
			path: '/rate-esclation-configuration',
			name: 'rate-esclation-configuration',
			component: () => import( './redesign/RateEsclationConfiguration/RateEsclationConfiguration.vue'
			),
		},
		{
			path: '/product-configuration',
			name: 'product-configuration',
			component: () => import( './redesign/Admin/ProductConfiguration.vue'
			),
		},
		{
			path: '/settings',
			name: 'settings',
			component: () => import( './redesign/Admin/Settings.vue'
			),
		},
		{
			path: '/staff-persona',
			name: 'staff-persona',
			component: () => import( './redesign/StaffPersona/StaffPersona.vue'
			),
		},
		{
			path: '/privacy-policy',
			name: 'privacy-policy',
			component: () => import('./redesign/Admin/Main.vue'
			),
			children: [
				{
					path: 'configuration',
					name: 'configuration',
				},
				{
					path: 'logs',
					name: 'logs',
				},
				{
					path: 'preferences-introduction',
					name: 'preferences-introduction',
				},
			],
		},
		{
			path: '/old/login',
			component: () => import('./containers/Login.vue'
			),
		},
		{
			path: '/managers/add',
			name: 'managersAdd',
			component: () => import( './redesign/ManagerList/AddManager.vue'
			),
		},
		{
			path: '/old/login',
			component: () => import('./containers/Login.vue'
			),
		},
		{
			path: '/verified',
			name: 'verified',
			component: () => import('./containers/VerifyUser.vue'
			),
		},
		{
			path: '/verifyUserEmail/:token',
			name: 'verify-user-email',
			component: () => import(
				'./redesign/Users/UserEmailVerify.vue'
			),
		},
		{
			path: '/verifyChangedEmail/:token',
			name: 'verify-changed-email',
			component: () => import(
				'./redesign/Users/ChangedEmailVerify.vue'
			),
		},
		{
			path: '/restrict-range-configuration',
			name: 'restrictRangeConfiguration',
			component: () => import( './redesign/BandMapping/BandMapping.vue'
			),
		},
		{
			path: '/hiFiReason/new',
			name: 'hiFiReason',
			component: () => import( './redesign/HiFiAwardReason/hiFiAwardReason.vue'
			),
		},
		{
			path: '/manager-reports',
			name: 'managerReports',
			component: () => import( './redesign/ManagerReports/MainView.vue'
			),
		},
		{
			path: '/cancellation-reports',
			name: 'cancellationReports',
			component: () => import( './redesign/CancellationReports/Main.vue'
			),
		},
		{
			path: '/roles/list',
			name: 'rolesList',
			component: () => import( './redesign/Roles/Roles.vue'
			),
		},

		{
			path: '/role/new',
			name: 'createRoles',
			component: () => import( './redesign/Roles/CreateNewRole.vue'
			),
		},

		{
			path: '/role/edit/:id',
			name: 'editRole',
			component: () => import( './redesign/Roles/CreateNewRole.vue'
			),
		},
		{
			path: '/role/copy/:id',
			name: 'copyRole',
			component: () => import( './redesign/Roles/CreateCopyRole.vue'
			),
		},
		{
			path: '/rateEscalationChecklist/new',
			name: 'rateEscalationChecklist',
			component: () => import( './redesign/RateEscalationChecklist/RateEscalationChecklist.vue'
			),
		},
		{
			path: '/approvedReasonsConfiguration/new',
			name: 'approvedReasonsConfiguration',
			component: () => import( './redesign/ApprovedReasonsConfiguration/ApprovedReasonsConfiguration.vue'
			),
		},
		{
			path: '/rejectReasonsConfiguration/new',
			name: 'rejectReasonsConfiguration',
			component: () => import( './redesign/RejectReasonsConfiguration/RejectReasonsConfiguration.vue'
			),
		},
		{
			path: '/reportCancellation/new',
			name: 'reportCancellation',
			component: () => import( './redesign/ReportCancellationReason/reportCacellationReason.vue'
			),
		},
		{
			path: '/job-prediction-configuration',
			name: 'jobPredictionConfiguration',
			component: () => import( './redesign/JobPredictionConfiguration/JobPredictionConfiguration.vue'
			),
		},

		{
			path: '/HiFiAwards/list',
			name: 'HiFiAwards',
			component: () => import( './redesign/HiFiAwards/HiFiAward.vue'
			),
		},
		{
			path: '/Staff-HiFiAwards',
			name: 'StaffHiFiAwards',
			component: () => import( './redesign/HiFiAwards/StaffHiFiAward.vue'
			),
		},
		{
			path: '/substantiveJoinners',
			name: 'substantiveJoinners',
			component: () => import('./redesign/SubstantiveUser/substantiveUsers.vue'),
			children: [
				  {
					path: '/substantiveLeavers',
					name: 'substantiveLeavers',
				  },
			],
		},
		{
			path: '/syncUsersHistory',
			name: 'syncUsersHistory',
			component: () => import('./redesign/SyncUsersHistory/syncUsersHistory.vue'),
		},
		{
			path: '/unMappedUsers',
			name: 'unMappedUsers',
			component: () => import('./redesign/SyncUsersHistory/unMappedUsers.vue'),
		},
		{
			path: '/onBoardedUsers',
			name: 'onBoardedUsers',
			component: () => import('./redesign/SyncUsersHistory/onBoardedUsers.vue'),
		},
		{
			path: '/unfilled-shifts-reason',
			name: 'unfilledShiftsReason',
			component: () => import('./redesign/UnfilledShiftsReason/UnfilledShiftsReason.vue'),
		},
		{
			path: '/unfilled-shifts-configuration',
			name: 'unfilledShiftsConfiguration',
			component: () => import('./redesign/UnfilledShiftsNudgeTimeConfiguration/NudgeTimeConfiguration.vue'),
		},
		{
			path: '/personaMappings/list',
			name: 'personaMappings',
			component: () => import('./redesign/PersonaMappings/Main.vue'),
		},
		{
			path: '/shifts/new',
			name: 'create-new-shift',
			component: () => import('./redesign/ShiftCreation/CreateShift.vue'
			),
		},
		{
			path: '/shifts/new/template',
			name: 'new-template',
			component: () => import('./redesign/ShiftCreation/NewJobTemplateSelection.vue'
			),
		},
		{
			path: '/shifts/new/selected-template',
			name: 'SelectedPersona',
			component: () => import('./redesign/ShiftCreation/SelectedPersona.vue'
			),
		},
		{
			path: '/shifts/new/add-capability',
			name: 'addPersonaCapability',
			component: () => import('./redesign/ShiftCreation/AddPersonaCapability.vue'
			),
		},
		{
			path: '/shifts/new/teach-persona',
			name: 'teachPersona',
			component: () => import('./redesign/ShiftCreation/TeachPersona.vue'
			),
		},
		{
			path: '/shifts/new/shift-summary',
			name: 'shiftSummary',
			component: () => import('./redesign/ShiftCreation/ShiftSummary.vue'
			),
		},
		{
			path: '/shifts/new/staff-skills',
			name: 'staffSkills',
			component: () => import('./redesign/ShiftCreation/StaffSkills.vue'
			),
		},
		{
			path: '/search/staff',
			name: 'search-staff',
			component: () => import('./redesign/SearchStaff/MainList.vue'
			),
		},
		{
			path: '/search/staff/persona',
			name: 'search-staff-persona',
			component: () => import('./redesign/SearchStaff/SearchPersona.vue'
			),
		},
		{
			path: '/user-endorsement-history',
			name: 'userEndorsementHistory',
			component: () => import( './redesign/Users/UserEndorsementHistory.vue'
			),
		},
		{
			path: '/syncWithOptima',
			name: 'sync-with-optima',
			component: () => import('./redesign/UserList/SyncWithOptima.vue'),
		},
		{
			path: '/syncUser',
			name: 'sync-user',
			component: () => import('./redesign/UserList/SyncUser.vue'),
		},
		{
			path: '/syncWithOptimaNurseUsers',
			name: 'sync-with-optima-nurse-users',
			component: () => import('./redesign/Manager/SyncWithOptimaNurseUsers.vue'),
		},

		// {
		// 	path: '/network-graph',
		// 	name: 'networkGraph',
		// 	component: () => import('./redesign/Vis/NetworkGraph.vue'),
		// },
		{
			path: '/skill-tree',
			name: 'skillTree',
			component: () => import('./redesign/SkillTree/SkillGraph.vue'),
		},
		{
			path: '/confidence-threshold',
			name: 'threshold',
			component: () => import('./redesign/ConfidenceScore/Threshold.vue'),
		},
		{
			path: '/export-trust-skills',
			name: 'exportTrustSkills',
			component: () => import('./redesign/ExportSkills/ExportTrustSkills.vue'),
		},
		{
			path: '/optima-rejected-users',
			name: 'optima-rejected-users',
			component: () => import('./redesign/Optima/OptimaRejectedUsers.vue'),
		},
		{
			path: '/autoAcceptanceTimerConfiguration',
			name: 'autoAcceptanceTimerConfiguration',
			component: () => import('./redesign/AutoOfferConfiguration/AutoAcceptanceTimer.vue'),
		},
		{
			path: '/Redeployment-Reason-Configuration',
			name: 'reasonConfiguration',
			component: () => import('./redesign/StaffRedeploymentReasons/RedeploymentReasons.vue'),
		},
		{
			path: '/upload-roster-shifts',
			name: 'upload-roster-shifts',
			component: () => import('./redesign/UploadRosterShifts/UploadRosterShifts.vue'),
		},
		{
			path: '/Filled-Shift-Configuration',
			name: 'filledShiftConfiguration',
			component: () => import('./redesign/filledShiftConfiguration/filledShiftReason.vue'),
		},
		{
			path: '/redeployment-requests',
			name: 'redeploymentRequests',
			component: () => import('./redesign/redeploymentRequest/redeploymentRequests.vue'),
		},
		{
			path: '/staff-swap-requests',
			name: 'swapRequests',
			component: () => import('./redesign/swapRequest/staffSwapRequests.vue'),
		},
		{
			path: '/manager-swap-requests',
			name: 'managerSwapRequests',
			component: () => import('./redesign/swapRequest/managerSwapRequests.vue'),
		},
		
		{
			path: '/user-form-wizard/:id',
			name: 'userApprovalForm',
			component: () => import('./redesign/userApproval/formWizardForUserApproval.vue'),
		},
		{
			path: '/userList/approvePermissions/:id',
			name: 'userApproval',
			component: () => import('./redesign/UserList/approvedPostings.vue'),
		},
		{
			path: '/userList/onboardUsers/:id',
			name: 'onboardUsers',
			component: () => import('./redesign/UserList/onboardUser.vue'),
		}
	],
});

export default router;
